module.exports = __webpack_public_path__ + "media/images/category/dummy/bottoms02-a51969cf55a3d4c822d0777a9961fe53.jpg";